import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import  styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const ExerciseAndActivityLearnMore: React.FC = () => {
const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionPlans = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}SlowHourglass2.png`} className={styles.highlightsItemHeaderImgIcon}  styles={{fontSize: '3em'}} />
                  <p className={styles.highlightsItemHeaderTitle} >START SLOWLY</p>
                  <Header.Subheader >  
                    <p className={styles.highlightsItemSubHeaderText} >It is important to start slow when it comes to exercising to avoid injury. Start with 
                        low-intensity exercises and light walking.</p>  
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}AwarenessOfSpace2.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlarge}`} styles={{fontSize: '2em'}}/>
                  <p className={styles.highlightsItemHeaderTitle} >PAY ATTENTION </p>
                  <Header.Subheader > 
                    <p className={styles.highlightsItemSubHeaderText} ><b>Pay attention to your surroundings!</b><br/> Make sure to clear the area of any trip 
                        hazards or things that may get in the way </p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}ConsultDoctor.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >CONSULT DOCTOR</p> 
                  <Header.Subheader > 
                    <p className={styles.highlightsItemSubHeaderText} >Always be sure to discuss this and be cleared by a provider before starting any 
                        fitness program. </p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Apparel.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >APPAREL & SHOES</p>
                  <Header.Subheader >  
                    <p className={styles.highlightsItemSubHeaderText} ><b>Wear appropriate fitness clothing and shoes.</b><br/> You should wear clothes that are 
                        loose and comfortable, but keep in mind that you don't want any clothing that gets in the way of the activity. To find the right 
                        shoes, head to your local athletic shoe store and describe what activities you plan on doing and they will make sure you have the 
                        right shoe and the right fit.</p>  
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Hydrate.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >STAY HYDRATED </p>
                  <Header.Subheader > 
                    <p className={styles.highlightsItemSubHeaderText} >It is important to not only drink water during your activity, but 
                        before and after too. Drinking water before prepares your body for sweating. Drinking water during and after replaces fluid lost 
                        during exercise. <br/><br/>
                        <span><b>
                        <a href="https://www.mayoclinic.org/healthy-lifestyle/nutrition-and-healthy-eating/in-depth/water/art-20044256"
                        target="_blank"
                        rel="noreferrer" >How much should you drink every day? [Mayo Clinic]{" "} </a>
                        </b></span></p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}ActiveIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >WARMUP & COOLDOWN</p> 
                  <Header.Subheader > 
                    <p className={styles.highlightsItemSubHeaderText} ><b>Be sure to always include a warmup and cool down.</b><br/> A warmup gradually 
                        revs up your cardiovascular system by raising your body temperature and increasing blood flow to your muscles. Warming up 
                        may also help reduce muscle soreness and lessen your risk of injury. Cooling down after your workout allows for a gradual 
                        recovery of preexercise heart rate and blood pressure. <br/><br/>
                        <span><b>
                            <a href="https://www.mayoclinic.org/healthy-lifestyle/fitness/in-depth/exercise/art-20045517#:~:text=A%20warmup%20gradually%20revs%20up,heart%20rate%20and%20blood%20pressure"
                            target="_blank"
                            rel="noreferrer" >How to warm up and cool down. [Mayo Clinic]{" "} </a>
                            </b></span>
                        </p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'plans',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips to Start a Senior Exercise Routine </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionPlans()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}ExerciseAndActivityPlanLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(ExerciseAndActivityLearnMore);
